import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { FindPasswordStyled } from '../../asset/styled/FindPasswordStyled';
import DetailHeader from '../../components/header/DetailHeader';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import { setStep } from './findByPasswordSlice';

const FindPassword = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('findPassword');
  const { t: tCommon } = useTranslation('common');
  const { step } = useSelector(state => state.findByPassword);

  // const step = 5;
  const stepHandler = step => {
    dispatch(setStep(step));
  };

  const renderStep = () => {
    // 이름 생년월일 입력
    if (step === 1) return <Step1 stepHandler={stepHandler} />;
    // 회사선택
    if (step === 2) return <Step2 stepHandler={stepHandler} />;
    // 연락처 선택
    if (step === 3) return <Step3 stepHandler={stepHandler} />;
    // 인증번호 입력
    if (step === 4) return <Step4 stepHandler={stepHandler} />;
    // 비밀번호 재설정
    if (step === 5) return <Step5 stepHandler={stepHandler} />;
  };

  return (
    <>
      <DetailHeader title={tCommon('header.title11')} />
      <FindPasswordStyled>{renderStep()}</FindPasswordStyled>
    </>
  );
};

export default FindPassword;
